import { normalizeText } from './normalize-text.util';

export function includesNormalized(haystack: string, needle: string): boolean {
    const n = normalizeText(needle);
    if (!n) return true;
    return normalizeText(haystack).includes(n);
}
